/**
 * Map admin resolve API payload to a catalog/cart row shape.
 */
export function resolveResultToCatalogRow(data) {
  const unitCost =
    data.unit_cost != null
      ? Number(data.unit_cost)
      : data.unit_price != null
        ? Number(data.unit_price)
        : 0;
  const available = Math.max(0, Number(data.available_quantity) || 0);

  return {
    admin_product_id: data.admin_product_id,
    id: data.inventory_id || data.admin_product_id,
    inventory_id: data.inventory_id,
    sku: data.article_code,
    product_name: data.product_name,
    unit_cost: unitCost,
    unit_price: data.unit_price,
    available_quantity: available,
    out_of_stock: available < 1,
    delivery_estimate: data.delivery_estimate ?? null,
    outside_mapped_location: Boolean(data.outside_mapped_location),
    warnings: Array.isArray(data.warnings) ? data.warnings : [],
    images: [],
  };
}
